import { combineReducers } from 'redux';
import { datastore as datastoreCore } from '@breezeway/brzw-react-core';

export default combineReducers({
  company: combineReducers({
    buildings: datastoreCore.companyReducers.buildings,
    businessHours: datastoreCore.companyReducers.businessHours,
    company: datastoreCore.companyReducers.company,
    companyGroups: datastoreCore.companyReducers.companyGroups,
    features: datastoreCore.companyReducers.features,
    homes: datastoreCore.companyReducers.homes,
    homeTags: datastoreCore.companyReducers.homeTags,
    messagesSettings: datastoreCore.companyReducers.messagesSettings,
    people: datastoreCore.companyReducers.people,
    permissions: datastoreCore.companyReducers.permissions,
    settings: datastoreCore.companyReducers.settings,
    supplies: datastoreCore.companyReducers.supplies,
    tags: datastoreCore.companyReducers.tags,
    templates: datastoreCore.companyReducers.templates,
    userPropertyIds: datastoreCore.companyReducers.userPropertyIds,
    workers: datastoreCore.companyReducers.workers,
    workflows: datastoreCore.companyReducers.workflows,
  }),
  properties: datastoreCore.reducers.properties,
  reservations: datastoreCore.reducers.reservations,
  summaryCounts: datastoreCore.reducers.summaryCounts,
  taskComments: datastoreCore.reducers.taskComments,
  taskDrafts: datastoreCore.reducers.taskDrafts,
  taskOffers: datastoreCore.reducers.taskOffers,
  taskPhotos: datastoreCore.reducers.taskPhotos,
  taskSeries: datastoreCore.reducers.taskSeries,
  taskTemplates: datastoreCore.reducers.taskTemplates,
  tasks: datastoreCore.reducers.tasks,
  types: datastoreCore.reducers.types,
});
